import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const LinkExpiredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  justify-content: center;
  height: 100vh;
  padding: 20px;
  .img-container {
    display: flex;
    margin-bottom: 15px;
    width: 100%;
    justify-content: center;
    align-items: center;

    svg {
      &:nth-child(1),
      &:nth-child(3) {
        @media (max-width: 1024px) {
          display: none;
        }
      }

      &:nth-child(2) {
        @media (max-width: 1024px) {
          transform: scale(0.7);
        }

        @media (max-width: 768px) {
          transform: scale(0.5);
        }

        @media (max-width: 480px) {
          transform: scale(0.4);
        }
      }
    }
  }
  label {
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
  }
  span {
    color: #856404;
    font-size: 14px;
    text-align: center;
  }
  button {
    background-color: ${theme.colours.mainBlue};
    color: white;
    border-radius: 12px;
    font-size: 14px;
    padding: 7px 25px;
    border: none;
    line-height: 22px;
    cursor: pointer;
  }
`;

